// extracted by mini-css-extract-plugin
module.exports = {"adIndicator":"s8H5jqwtsDfmm8eIwDASB","timeContainer":"_2SK53A4llk8bYEJUGV5jyi","timeIndicator":"_3ziizC7Oyraw31sYB0l4at"};